import { Navigate } from 'react-router-dom';
import { useParams } from "react-router";
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import Corporations from "./Corporations.jsx";
import Campuses from "./Campuses.jsx";
import AllServers from "./AllServers.jsx";
import AllServersPage from "../pages/customers/servers/AllServersPage.jsx";
import CampusesPage from "../pages/customers/campuses/CampusesPage.jsx";
import CorporationsPage from "../pages/customers/corporations/CorporationsPage.jsx";
import {iAmHigherAuthority} from "../libs.jsx";
import SessionReload from "./component-assets/SessionReload.jsx";
import PalPendantMap from "./PalPendantMap.jsx";
import { getSession } from "../services/session";

const Customers = (props) => {
    let pageContent, dData, paramVars, bData;
    paramVars = useParams();
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';

    dData = getSession();

    if (paramVars?.dType === "corporations") {
        pageContent = isV2 ? <CorporationsPage /> : <Corporations/>
    }else if (paramVars?.dType === "campuses"){
        pageContent = isV2 ? <CampusesPage /> : <Campuses />
    }else if (paramVars?.dType === "servers"){
        pageContent = isV2 ? <AllServersPage /> : <AllServers />;
    }else{
        pageContent = (
            <div>
                404 Page not found
            </div>
        );
    }

    return (iAmHigherAuthority(80, dData?.my_role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {pageContent}
        </>
    ) : <Navigate to={"/"}/>;
};

export default Customers;